import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import {
  Button,
  Collapse,
  Nav,
  Navbar,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { showModal } from '../../actions';

import { isLoggedIn } from '../../api/Auth';

import NotificationsDropdown from '../NotificationsDropdown';
import ProfileMenu from '../ProfileMenu';
import WorkspaceLink from '../WorkspaceLink';
import HeaderDivider from '../HeaderDivider';

class ShareHeader extends PureComponent {
  constructor(props) {
    super(props);

    this.handleDownloadShareFiles = this.handleDownloadShareFiles.bind(this);
  }

  handleDownloadShareFiles() {
    const {
      dispatch,
      share,
    } = this.props;

    dispatch(showModal('DownloadModal', {
      className: 'modal-download',
      files: [],
      shareUuid: share.uuid,
      downloadAll: true,
      backdrop: true,
      requireName: share.require_name,
      requireEmail: share.require_email,
    }));
  }

  render() {
    const {
      intl,
      profile,
      share,
      notFound,
      providePassword,
    } = this.props;

    if (!share && !notFound) {
      return null;
    }

    if (notFound) {
      const logoUrl = (profile && profile.client) ? profile.client.share_logo_url : null;

      return (
        <div className="share-header">
          <Link to="/" className="share-logo">
            <img src={share?.logo_url || logoUrl || '/logo/share'} alt="Stockpress" />
          </Link>
        </div>
      );
    }

    return (
      <div className="toolbar">
        <Navbar className="navbar-expand share-header">
          <div>
            <Link to="/" className="share-logo">
              <img
                src={share.logo_url || share.client.share_logo_url}
                alt={share.client.name || share.client.subdomain}
              />
            </Link>
          </div>
          <div>
            {(share.allow_download && !providePassword) && (
              <div className={classnames('share-actions', { 'share-actions-spacing': (isLoggedIn()) })}>
                <Button
                  color="primary"
                  size="lg"
                  onClick={this.handleDownloadShareFiles}
                >
                  <i className="far fa-download" />
                  {intl.formatMessage({ defaultMessage: 'Download all' })}
                </Button>
              </div>
            )}
            {profile && isLoggedIn() && (
              <Collapse isOpen={true} navbar className="nav-actions">
                <Nav className="ml-auto" navbar>
                  <WorkspaceLink share={share} />
                  <HeaderDivider />
                  <NotificationsDropdown />
                  <ProfileMenu />
                </Nav>
              </Collapse>
            )}
          </div>
        </Navbar>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  providePassword: state.Shares.providePassword,
});

ShareHeader.propTypes = {
  intl: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  profile: PropTypes.object,
  share: PropTypes.object,
  notFound: PropTypes.bool,
  providePassword: PropTypes.bool.isRequired,
};

ShareHeader.defaultProps = {
  profile: null,
  share: null,
  notFound: false,
};

export default connect(mapStateToProps)(injectIntl(ShareHeader));
